import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import './App.css';
import { ColumnDirective, ColumnsDirective, GridComponent } from '@syncfusion/ej2-react-grids';
import { Toolbar, Sort, Inject } from '@syncfusion/ej2-react-grids';
import firebase from "firebase/app";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Input from '@material-ui/core/Input';
import _, { chain } from 'lodash';
import MaskedInput from 'react-text-mask';

const styles = (theme) => ({
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
});

const Mask = ({ inputRef, ...other }) => {                                  
    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/\d/, /\d/, ':', /[0-5]/, /\d/, ':', /[0-5]/, /\d/]}
      />
    );
};
const collection = "results";
const sortSettings = { columns: [{ field: 'time', direction: 'Ascending' }] };
const getDefaultResult = () => ({
    type: "",
    number: "",
    name: "", category: "", time: ""
})

const App = () => {
    const history = useHistory();
    const [results, setResults] = useState([]);
    const [result, setResult] = useState(null);
    const [isEditing, setIsEditing] = useState(null);
    const [selectedResult, setSelectedResult] = useState(null);
    const [type, setType] = useState(42);
    const [user, setUser] = useState(firebase.auth().currentUser);
    const isAuthentified = !!user;

    useEffect(() => {
        firebase.firestore().collection(collection).onSnapshot(snapshot => {
            setResults(snapshot.docs.map((doc) => doc.data()));
        });
    }, []);

    firebase.auth().onAuthStateChanged(newUser => setUser(newUser));

    return (
        <div className="CenterContainer">
            <div>
                {isAuthentified ? (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={async () => await firebase.auth().signOut()}
                    >
                        Se Déconnecter
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => history.push("/login")}
                    >
                        Se Connecter
                    </Button>
                )}
                <Button variant="outlined" color="primary" onClick={() => setResult(getDefaultResult())}>
                    Ajouter un résultat
                </Button>
                {isAuthentified && (
                    <>
                        <Button disabled={!selectedResult} variant="outlined" color="primary" onClick={() => {
                             setResult({...selectedResult});
                             setIsEditing(true);
                        }}>
                            Modifier
                        </Button>
                        <Button disabled={!selectedResult} variant="outlined" color="primary" onClick={async () => {
                            await firebase.firestore().collection("results").doc(selectedResult.number).delete();
                            setSelectedResult(null);
                        }}>
                            Supprimer
                        </Button>
                    </>
                )}
            </div>
            {!!result && (
                <Dialog open={!!result} onClose={() => setResult(null)} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Résultat du participant</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Entrez votre résultat dans chacune des boites ci-dessous!
                        </DialogContentText>
                        <DialogContentText>
                            *** Il est important que chacun des champs soient remplis pour que le bouton ajouter soit disponible ***
                        </DialogContentText>
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-outlined-label">Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={result.type || ""}
                                onChange={(event) => setResult({ ...result, type: event.target.value })}
                                label="Type"
                            >
                                <MenuItem value="42">42.2 km</MenuItem>
                                <MenuItem value="21">21.1 km</MenuItem>
                                <MenuItem value="15">15 km</MenuItem>
                                <MenuItem value="10">10 km</MenuItem>
                                <MenuItem value="5">5 km</MenuItem>
                                <MenuItem value="3">3 km</MenuItem>
                                <MenuItem value="1">1 km</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            id="number"
                            margin="dense"
                            value={result.number}
                            label="Dossard"
                            variant="outlined"
                            type="number"
                            fullWidth
                            required
                            onChange={(event) => setResult({ ...result, number: event.target.value })}
                        />
                        <TextField
                            id="name"
                            margin="dense"
                            value={result.name}
                            label="Nom"
                            variant="outlined"
                            fullWidth
                            onChange={(event) => setResult({ ...result, name: event.target.value })}
                        />
                         <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-outlined-label">Catégorie</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={result.category || ""}
                                onChange={(event) => setResult({ ...result, category: event.target.value })}
                                label="Catégorie"
                            >
                                <MenuItem value="M10-19">M10-19</MenuItem>
                                <MenuItem value="M20-29">M20-29</MenuItem>
                                <MenuItem value="M30-39">M30-39</MenuItem>
                                <MenuItem value="M40-49">M40-49</MenuItem>
                                <MenuItem value="M50-59">M50-59</MenuItem>
                                <MenuItem value="M60-69">M60-69</MenuItem>
                                <MenuItem value="M70-79">M70-79</MenuItem>
                                <MenuItem value="M80-89">M80-89</MenuItem>
                                <MenuItem value="M90-99">M90-99</MenuItem>
                                <MenuItem value="F10-19">F10-19</MenuItem>
                                <MenuItem value="F20-29">F20-29</MenuItem>
                                <MenuItem value="F30-39">F30-39</MenuItem>
                                <MenuItem value="F40-49">F40-49</MenuItem>
                                <MenuItem value="F50-59">F50-59</MenuItem>
                                <MenuItem value="F60-69">F60-69</MenuItem>
                                <MenuItem value="F70-79">F70-79</MenuItem>
                                <MenuItem value="F80-89">F80-89</MenuItem>
                                <MenuItem value="F90-99">F90-99</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            id="time"
                            margin="dense"
                            value={result.time}
                            label="Temps Officiel"
                            variant="outlined"
                            fullWidth
                            InputProps={{inputComponent: Mask}}
                            onChange={(event) => setResult({ ...result, time: event.target.value })}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth onClick={() => setResult(null)} color="primary">
                            Cancel
                        </Button>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={result.name === "" || result.type === "" || result.number === "" || result.time === "" || result.category === ""}
                            onClick={async () => {
                                await firebase.firestore().collection(collection).doc(result.number).set(result);
                                setResult(null);
                                setIsEditing(false);
                            }}
                            onClose
                        >
                            {isEditing ? 'Modifier' : 'Ajouter'}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
            <Paper square>
                <Tabs
                    value={type}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={(_, value) => setType(value)}
                    aria-label="disabled tabs example"
                >
                    <Tab value={42} label="42.2 km" />
                    <Tab value={21} label="21.1 km" />
                    <Tab value={15} label="15 km" />
                    <Tab value={10} label="10 km" />
                    <Tab value={5} label="5 km" />
                    <Tab value={3} label="3 km" />
                    <Tab value={1} label="1 km" />
                </Tabs>
            </Paper>
            <GridComponent
                dataSource={chain(results.filter(element => element.type === type.toString())).sortBy(['time']).map((doc, index) => ({...doc, position: index + 1})).value()}
                allowSorting
                searchSettings={{ignoreAccent: true, fields: ['name', 'number']}}
                sortSettings={sortSettings}
                height={315}
                toolbar={['Search']}
                rowSelected={(event) => setSelectedResult(event.data)}
            >
                <ColumnsDirective>
                    <ColumnDirective field='position' headerText='RANG' width='100' textAlign="Center" />
                    <ColumnDirective field='number' headerText='DOSSARD' width='100' textAlign="Center"/>
                    <ColumnDirective field='name' headerText='NOM' width='100' textAlign="Center" />
                    <ColumnDirective field='category' headerText='CATÉGORIE' width='100' textAlign="Center" />
                    <ColumnDirective field='time' headerText='TEMPS OFFICIEL' width='100' textAlign="Center" />
                </ColumnsDirective>
                <Inject services={[Toolbar, Sort]} />
            </GridComponent>
        </div>
    );
}

export default withStyles(styles)(App)

//Faire que en ajoutant le temps, la catégorie, nom de la personne et dossard, la position des coureurs se fasse tout seule.

//<ColumnDirective field='sexPosition' headerText='PLACE SEXE' width='100' textAlign="Center" />
//<ColumnDirective field='categoryPosition' headerText='PLACE CAT.	' width='100' textAlign="Center" />*/

/*<TextField
    id="sexPosition"
    margin="dense"
    value={result.sexPosition}
    label="Place sexe"
    variant="outlined"
    fullWidth
    onChange={(event) => setResult({ ...result, sexPosition: event.target.value })}
/>
<TextField
    id="categoryPosition"
    margin="dense"
    value={result.categoryPosition}
    label="Place Cat"
    variant="outlined"
    fullWidth
    onChange={(event) => setResult({ ...result, categoryPosition: event.target.value })}
/>*/